import PageHeader from 'components/common/PageHeader';
import React, { useEffect } from 'react';
import RealEstate from './components/RealEstate';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRealEstateByUserId,
  getRealEstateData
} from 'redux/realEstateSlice';
import FormNuevaInmobiliaria from './form/FormNuevaInmobiliaria';

const RealEstatePage = () => {
  const realEstate = useSelector(state => state.realEstate.realEstate);
  const userLogged = useSelector(state => state.login.currentUser);
  const dispatch = useDispatch();

  useEffect(() => {
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  useEffect(() => {
    if (realEstate.id) {
      dispatch(getRealEstateData(realEstate.id));
    }
  }, [realEstate]);

  return (
    <>
      <PageHeader
        title="Gestionar Inmobiliaria"
        description="En esta sección puede gestionar los datos de su inmobiliaria."
        className="mb-3 bg-white"
      />

      {userLogged?.realEstateId ? <RealEstate /> : <FormNuevaInmobiliaria />}
    </>
  );
};

export default RealEstatePage;
